import { ValueOf } from 'global';
import {
  FACT_NAMES_STRING,
  ENGINE_TORQUE_MODE,
  FACT_NAMES_NUMERIC,
  EQUIPMENT_ENGINE_TYPE,
} from '@trnsact/business-criteria';
import { EquipmentSourcedRequiredOptionsValue, Fact, FinanceProgramFormValues } from '../types';

export const equipmentDependentFields: (keyof ValueOf<Pick<FinanceProgramFormValues, 'equipment'>, 'equipment'>)[] = [
  'year',
  'make',
  'model',
  'class',
  'stockId',
  'newUsed',
  'quantity',
  'description',
  'retailPrice',
  'serialNumberVin',
  'totalWholesaleCost',
];

// Required Options for Dynamic Fields. Will be added to options even if the current product set does not support it.
export const requiredOptionsForDynamicFields: Record<Fact, string[]> = {
  [FACT_NAMES_STRING.AFTERMARKET_PRODUCT_SOURCE]: [
    EquipmentSourcedRequiredOptionsValue.DTRSourced,
    EquipmentSourcedRequiredOptionsValue.NonDTRSourced,
  ],
  [FACT_NAMES_STRING.ENGINE_TORQUE_MODE]: Object.values(ENGINE_TORQUE_MODE),
  [FACT_NAMES_STRING.EQUIPMENT_ENGINE_TYPE]: Object.values(EQUIPMENT_ENGINE_TYPE),
};

export const factsKeyMapToFieldLabel: Record<Fact, string> = {
  [FACT_NAMES_STRING.AFTERMARKET_PRODUCT_SOURCE]: 'EQUIPMENT SOURCE',
  [FACT_NAMES_STRING.COVERAGE_TERM]: 'Set Coverage Term to Finance Term',
  [FACT_NAMES_NUMERIC.DEAL_SIZE]: 'AMOUNT ($)',
};
